import _                           from 'underscore';
import classNames                  from 'classnames';
import React, { FC, useMemo }      from 'react';
import { Icon, Label, LabelProps } from 'semantic-ui-react';

import { EMPTY_VALUE_DISPLAY }                                                    from '../../../constants/FormatStringEnums';
import { adjustBrightness, hexToRGBa, isColorDark, runIfFunction, stringToColor } from '../../../util';
import { CorvalColor }                                                            from '../../../types';

export interface TagProps {
	content?: string,
	colorized?: boolean,
	defaultColor?: CorvalColor,
	
	onRemove?( content: string ): void
	
	onClick?( content: string ): void
}

const defaultProps: TagProps = {
	content:      EMPTY_VALUE_DISPLAY,
	colorized:    false,
	defaultColor: 'lightBrine',
	onRemove:     null,
	onClick:      null,
}

const Tag: FC<TagProps> = ( props ) => {
	
	let { colorized, content } = props;
	
	let labelProps = {
		circular: true,
	} as LabelProps;
	
	let hasOnClickHandler  = _.isFunction( props.onClick ),
	    hasOnRemoveHandler = _.isFunction( props.onRemove );
	
	let tagColor       = useMemo( () => stringToColor( content, 92, 38, true ) as string, [ content ] ),
	    tagColorIsDark = useMemo( () => isColorDark( tagColor ), [ content ] );
	
	// Classes
	labelProps[ 'className' ] = classNames( {
		'cursor--default':    !hasOnClickHandler,
		'cursor--pointer':    hasOnClickHandler,
		'opacity--90':        hasOnClickHandler,
		'opacity-hover--100': hasOnClickHandler,
	} );
	
	// Colorization Styles
	if( colorized ){
		
		labelProps[ 'style' ] = {
			...( { ...labelProps.style ?? {} } ),
			borderColor:     tagColorIsDark ? adjustBrightness( tagColor, -5 ) : adjustBrightness( tagColor, -25 ),
			backgroundColor: tagColorIsDark ? tagColor : adjustBrightness( tagColor, -20 ),
			color:           hexToRGBa( '#FFFFFF', '0.8' )
		}
		
		labelProps = { ...labelProps, basic: true }
		
	} else if( !labelProps.color ){
		
		labelProps = { ...labelProps, color: props.defaultColor }
		
	}
	
	const handleClicked = () => {
		
		runIfFunction( props.onClick, content );
	}
	
	const handleRemoveClicked = () => {
		
		runIfFunction( props.onRemove, content );
	}
	
	return (
		
		<Label onClick={ handleClicked } { ...labelProps }>
			{ content }
			{ hasOnRemoveHandler && <Icon name={ 'delete' } onClick={ handleRemoveClicked }/> }
		</Label>
	);
};

Tag.defaultProps = defaultProps;

export { Tag }
